import * as firebase from 'firebase/app';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider} from "firebase/auth";
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyATtDeU1Va5OPTmult3J091WE7isw49L_8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "traderdashboard-72a57.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "traderdashboard-72a57",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "traderdashboard-72a57.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "174423554653",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:174423554653:web:c412d54ccd1ed7dd642bb4",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-853X6XJ1NT"
};

export let firebaseApp: FirebaseApp | undefined;

if (!firebase.getApps().length) {
  firebaseApp = initializeApp(firebaseConfig);
}

export const appFirebaseAuth = getAuth(firebaseApp);
setPersistence(appFirebaseAuth, browserLocalPersistence);

export const googleProvider = new GoogleAuthProvider();

// Initialize Firebase Functions
export const functions = getFunctions(firebaseApp);